import(/* webpackMode: "eager" */ "/var/www/mindbalance-web/src/app/(Guest)/pages/[slug]/page.js")